import React, { useCallback, useMemo, useState } from "react";
import { useWizard } from 'components/wizard/WizardContext';
import { Card, CardBody, Row } from "reactstrap";
import { useFetchVendorStudentMappings } from "../customHook";
import { getPaymentMappingPayload } from "../helper";
import ALoader from "views/pages/manage/common/a-loader";
import ListComponent from "./ListComponent";
import { formattedPrice } from "views/pages/manage/unAssigned/collectPayment/utils";
import styles from "../styles.module.scss";
import { endpoint } from "views/pages/manage/common/constant";
import { ReactComponent as DownArrow } from "assets/img/svg/downarrow.svg"
import { ReactComponent as Uparrow } from "assets/img/svg/upwardArrow.svg";

const StudentMappedDetails = ({ stream }) => {
    const { fetchStudentMappingList } = useFetchVendorStudentMappings();
    const { values } = useWizard();
    const vendorType = values?.vendorType;
    const streamKey = stream?.label;
    const streamData = values?.[streamKey];
    const [open, setOpen] = useState(true);


    const vendorId = values?.vendorDetails?.id;
    const businessAreaId = values?.addVendorForm?.businessArea?.value;
    const yearId = values?.addVendorForm?.year?.value;

    const tableHeading = vendorType !== 'INVIGILATOR' ? `Students mapped • ${streamKey}` : `Exams & pay hours • ${streamKey}`

    const payload = useMemo(() => {
        if (!vendorId || !businessAreaId || !yearId) return null;

        return getPaymentMappingPayload(
            {
                vendorDetails: values?.vendorDetails,
                addVendorForm: values?.addVendorForm
            },
            stream
        );
    }, [vendorId, businessAreaId, yearId, stream?.value]);

    const nextButtonHandler = useCallback(
        (newPage, pageSize) => {
            if (!payload) return;

            const url = vendorType?.toUpperCase() == 'INVIGILATOR' ? endpoint.raiseVendorRequest?.invigilator?.search : endpoint.raiseVendorRequest?.admissionAdvisor?.search

            fetchStudentMappingList(
                url,
                payload,
                newPage,
                pageSize,
                streamKey
            );
        },
        [payload, streamKey, fetchStudentMappingList]
    );

    if (!streamData?.hasData) return null;

    return (
        <>
            {streamData?.loading && <ALoader position="fixed" />}

            <Card style={{ padding: "22px" }}>
                <div className='d-flex justify-content-between align-items-center'>
                    <div className={`m-0 ${styles['label']}`}>{tableHeading}</div>
                    <div className="d-flex align-items-center cursor" style={{ gap: "23px" }} onClick={() => setOpen(prev => !prev)}>
                        <div>
                            Total Amount{" "}
                            <span className={styles['amount']}>
                                {formattedPrice(streamData?.totalAmount)}
                            </span>
                        </div>
                        {open ? <Uparrow /> : <DownArrow />}
                    </div>
                </div>

                {open && (
                    <>

                        {/* <div style={{ padding: "12px 0" }}> */}
                        <div style={{ marginTop: "12px", overflowX: "auto" }}>
                            <ListComponent
                                rows={streamData?.list}
                                paginationInfo={streamData?.paginationInfo}
                                nextButtonHandler={nextButtonHandler}
                                loading={streamData?.loading}
                            />
                        </div>
                        {/* </div> */}
                    </>
                )}
            </Card>
        </>
    );
};

export default React.memo(StudentMappedDetails);
